import React from 'react';
import { IDashboardTemplateFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import { appRoutes } from '../../../../../path';
import { DashboardNavSectionType } from '../../../types';
import DashboardTemplateActions from './DashboardTemplateActions';
import DashboardTemplateLink from './DashboardTemplateLink';

interface IProps {
  template: IDashboardTemplateFieldsFragment;
  variant: DashboardNavSectionType;
  mouseOverId: string | null;
  openedMenuId: string | null;
  setMouseOverId: (link: string | null) => void;
  setOpenedMenuId: (link: string | null) => void;
}

const DashboardTemplate = ({
  template,
  variant,
  mouseOverId,
  openedMenuId,
  setMouseOverId,
  setOpenedMenuId,
}: IProps) => {
  const baseId = template.baseId;
  const link = appRoutes.dashboard.generateLink(baseId);
  const isFocused = mouseOverId === baseId || openedMenuId === baseId;

  return (
    <DashboardTemplateLink
      href={link}
      onMouseEnter={() => {
        setMouseOverId(baseId);
      }}
      onMouseLeave={() => {
        setMouseOverId(null);
      }}
      title={template.name}
      isFocused={isFocused}
    >
      {isFocused && (
        <DashboardTemplateActions
          template={template}
          onOpen={() => {
            setOpenedMenuId(baseId);
          }}
          onClose={() => {
            setOpenedMenuId(null);
          }}
          onSelectOption={() => {
            setMouseOverId(null);
            setOpenedMenuId(null);
          }}
          variant={variant}
        />
      )}
    </DashboardTemplateLink>
  );
};

export default DashboardTemplate;
